import { MAX_NUMBER_OF_SECTIONS } from '../const/limits';
import { useAppSelector } from '../global/hooks';
import { selectSections } from '../store/sectionsSlice';

export default function useCanAddSection(): [boolean, string[]] {
	let canAddSection = true;
	let reasons = [];
	const sections = useAppSelector(selectSections);
	if (sections.length >= MAX_NUMBER_OF_SECTIONS) {
		canAddSection = false;
		reasons.push('Maximum number of sections reached');
	}
	const lastSection = sections[sections.length - 1];

	if (lastSection?.chords.length === 0) {
		canAddSection = false;
		reasons.push('Last section is empty');
	}

	return [canAddSection, reasons];
}
